import { models } from "../../utils/utils";
import accountService from "../api/accountService";
import { clearFiles } from "../events/filesEvents";
import {
  getSessionMessagesSuccess,
  getSessionsSuccess,
  setSelectedDataAnalysisFileSuccess,
  setSelectedDomainSuccess,
  setSelectedFilesSuccess,
} from "../events/sessionEvents";
import {
  clearAccountDetails,
  clearLocalStorage,
  getAccountDetails,
  getUserDetails,
  setAccount,
  setAIModel,
  setIsDebugModeOn,
  setUser,
} from "../storage/localStorage";

export function sendDiscoveryEmail(email) {
  return async (dispatch) => {
    try {
      const response = await accountService.sendDiscoveryEmail(email);
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function authenticateDiscoveryMagicLink(token) {
  return async (dispatch) => {
    try {
      const response = await accountService.authenticateDiscoveryMagicLink(
        token
      );
      const { user, account } = response;
      setUser(user);
      setAccount(account);
      if (process.env.REACT_APP_ENV === "staging") {
        setIsDebugModeOn(true);
        setAIModel(models[0]);
      }
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function sendMagicLink(email) {
  return async (dispatch) => {
    try {
      const response = await accountService.sendMagicLink(email);
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function authenticateMagicLink(token) {
  return async (dispatch) => {
    try {
      const response = await accountService.authenticateMagicLink(token);
      const { user, account } = response;
      setUser({
        ...user,
        isBannerOpen:
          account["plan"] === "free" && user["upgrade_request"] === false,
      });
      setAccount(account);
      if (process.env.REACT_APP_ENV === "staging") {
        setIsDebugModeOn(true);
        setAIModel(models[0]);
      }
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function upgradeRequest() {
  return async (dispatch) => {
    try {
      const response = await accountService.upgradeRequest();
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function getAccountDetailsFromApi(key) {
  return async (dispatch) => {
    try {
      const response = await accountService.getAccount(key);
      const { user, account } = response;
      setUser({
        ...user,
        isBannerOpen:
          account["plan"] === "free" && user["upgrade_request"] === false,
      });
      setAccount(account);
      if (process.env.REACT_APP_ENV === "staging") {
        setIsDebugModeOn(true);
        setAIModel(models[0]);
      }
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function getUserAndAccount() {
  return async (dispatch) => {
    try {
      const response = await accountService.getUserAndAccount();
      const userFromLocalStorage = getUserDetails();
      const { user, account } = response;
      setUser({
        ...user,
        isBannerOpen:
          account["plan"] === "free" && user["upgrade_request"] === false,
        session_jwt: userFromLocalStorage["session_jwt"] || null,
      });
      setAccount(account);
      if (account?.name === "Indorama RFP") {
        
      }
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function updateUser(user) {
  return async (dispatch) => {
    try {
      const response = await accountService.updateUser(user);
      setUser(user);
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function getAccountIdFromLocal() {
  try {
    const response = getAccountDetails();
    return response["id"];
  } catch (error) {
    console.log(error);
  }
}

export function getAccountNameFromLocal() {
  try {
    const response = getAccountDetails();
    return response["name"];
  } catch (error) {
    console.log(error);
  }
}

export function getAccountDetailsFromLocal() {
  try {
    const response = getAccountDetails();
    return response;
  } catch (error) {
    console.log(error);
  }
}

export function setAccountDetailsInLocal(response) {
  try {
    setAccount(response);
  } catch (err) {
    throw err;
  }
}

export function clearAccountDetailsFromLocal() {
  try {
    clearAccountDetails();
  } catch (err) {
    throw err;
  }
}

export function getAccountUsers() {
  return async (dispatch) => {
    try {
      const response = await accountService.getAccountUsers();
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function getRolesAndAccess() {
  return async (dispatch) => {
    try {
      const response = await accountService.getRolesAndAccess();
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function updateRolesAndAccess(roles) {
  return async (dispatch) => {
    try {
      const response = await accountService.updateRolesAndAccess(roles);
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function getDashboardData(domainId, dateFilter) {
  return async (dispatch) => {
    try {
      const response = await accountService.getDashboardData(
        domainId,
        dateFilter
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function updateUserByAdmin(userId, user) {
  return async (dispatch) => {
    try {
      const response = await accountService.updateUserByAdmin(userId, user);
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function deleteUserByAdmin(userId) {
  return async (dispatch) => {
    try {
      const response = await accountService.deleteUserByAdmin(userId);
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function logout(stytchUserId, sessionJwt, callSessionRevokeApi = true) {
  return async (dispatch) => {
    try {
      if (callSessionRevokeApi) {
        await accountService.logout(stytchUserId, sessionJwt);
      }
      clearDetailsUtil(dispatch);
    } catch (error) {
      clearDetailsUtil(dispatch);
      throw error;
    }
  };
}

export function clearDetails() {
  return async (dispatch) => {
    clearDetailsUtil(dispatch);
  };
}

function clearDetailsUtil(dispatch) {
  clearLocalStorage();
  dispatch(clearFiles());
  dispatch(getSessionMessagesSuccess([]));
  dispatch(getSessionsSuccess([]));
  dispatch(setSelectedDataAnalysisFileSuccess(null));
  dispatch(setSelectedFilesSuccess([]));
  dispatch(setSelectedDomainSuccess(null));
}
